<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <v-data-table
          :items="deliveryReceipts"
          :headers="deliveryHeaders"
          :expanded.sync="expanded"
          item-key="id"
          :search="search"
          show-expand
        >
          <template #top>
            <v-toolbar
              flat
            >
              <v-toolbar-title>
                Lieferscheine
              </v-toolbar-title>
              <v-divider
                class="mx-4"
                inset
                vertical
              />
              <v-text-field v-model="search" label="Suche" single-line append-icon="mdi-magnify" />
              <v-spacer />
              <v-btn color="primary" @click="createPrompt = true">
                ANLEGEN
              </v-btn>
              <v-dialog
                v-model="createPrompt"
                width="500"
              >
                <v-card class="pa-3">
                  <v-card-title>
                    Neuen Lieferschein Hinzufügen
                  </v-card-title>
                  <v-card-text>
                    <v-autocomplete v-model="invoiceNumber" item-text="invoice_number" item-value="invoice_number" :items="purchases" required label="Bestellnumer" />
                    <v-divider />
                    <v-card-acions>
                      <div class="d-flex justify-end mt-2">
                        <v-btn text color="primary" @click="create()">
                          <h4>
                            Anlegen
                          </h4>
                        </v-btn>
                      </div>
                    </v-card-acions>
                  </v-card-text>
                </v-card>
              </v-dialog>
              <v-dialog
                v-model="deletePrompt"
                width="500"
              >
                <v-card class="pa-3">
                  <v-card-title>
                    Lieferschein Löschen
                  </v-card-title>
                  <v-card-text>
                    Sind Sie sicher das sie den Lieferschein entfernen wollen?
                    <v-divider />
                    <v-card-acions>
                      <div class="d-flex justify-end mt-2">
                        <v-btn text color="primary" @click="softDelete()">
                          <h4>
                            Löschen
                          </h4>
                        </v-btn>
                      </div>
                    </v-card-acions>
                  </v-card-text>
                </v-card>
              </v-dialog>
            </v-toolbar>
          </template>
          <template #expanded-item="{ headers, item }">
            <td :colspan="headers.length">
              <v-simple-table class="ma-3">
                <template #default>
                  <thead>
                    <tr>
                      <th class="text-left">
                        Produkt Name
                      </th>
                      <th class="text-left">
                        Serien Nummer
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(purchaseItem, key) in item.purchase_item_data" :key="key">
                      <td>{{ purchaseItem.purchase_item.name }}</td>
                      <td>{{ purchaseItem.pivot.serial_number }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <div class="d-flex justify-end my-2">
                <v-btn text class="mr-2" @click="toDelete(item.id)">
                  ENTFERNEN
                </v-btn>
                <v-btn color="primary" @click="edit(item.id)">
                  BEARBEITEN
                </v-btn>
              </div>
            </td>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Layout from '@/Layouts/Admin'
export default {
   name: 'IncomingIndex',
   metaInfo () {
      return {
         title: this.title ? this.title : 'Lieferschein Übersicht',
      }
   },
   layout: (h, page) => h(Layout, [page]),
   props: {
      deliveryReceipts: {
         type: Array,
         required: true
      },
      purchases: {
         type: Object,
         required: true
      },
      warehouses: {
         required: true,
         type: Array
      }
   },
   data () {
      return {
         search: '',
         toDeleteEntry: null,
         invoiceNumber: null,
         createPrompt: false,
         deletePrompt: false,
         expanded: [],
         deliveryHeaders: [
            { text: 'Lieferschein Nummer', value: 'delivery_receipt_number' },
            { text: 'Bestell Nummer', value: 'purchase.invoice_number' },
            { text: 'Erstellt am', value: 'created_at' },
            { text: '', value: 'data-table-expand' },
         ],

      }
   },
   methods: {
      create () {
         if (this.invoiceNumber !== null && this.invoiceNumber !== '') {
            this.$inertia.get(this.route('delivery_receipt.create_with_invoice', this.invoiceNumber))
         }
      },
      edit (id) {
         this.$inertia.get(this.route('delivery_receipt.edit', id))
      },
      toDelete (id) {
         this.toDeleteEntry = id
         this.deletePrompt = true
      },
      softDelete () {
         this.$inertia.patch(this.route('delivery_receipt.soft_destroy', this.toDeleteEntry))
            .then((response) => (this.deletePrompt = false))
      },
   }
}
</script>

<style>

</style>
